import { Component } from '@angular/core';

@Component({
  selector: 'app-flexible-message',
  templateUrl: './flexible-message.component.html',
  styleUrls: ['./flexible-message.component.scss'],
})
export class FlexibleMessageComponent { }